import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  actions: {
    borderTopColor: theme.palette.gray.light,
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    padding: "10px 25px",
  },
}));
